import { getData } from "../Services/getData";
import { endpoints } from "../Utils/UrlEnum";

export interface DateRangeParams {
  startDate?: string;
  endDate?: string;
  preset?: string;
  groupBy?: string;

}

/**
 * Build query string from date range parameters
 */
const buildQueryString = (params: DateRangeParams): string => {
  const queryParams = new URLSearchParams();

  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.preset) queryParams.append("preset", params.preset);
  if (params.groupBy) queryParams.append("groupBy", params.groupBy);

  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : "";
};

// ==================== SALES REPORTS ====================

export const getSalesRevenueTrends = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.salesRevenueTrends}${queryString}`);
};

export const getSalesOrdersByStatus = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.salesOrdersByStatus}${queryString}`);
};

// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const getSalesTopProducts = (params: DateRangeParams = {}, limit: number = 10) => {
  const queryString = buildQueryString(params);
  const separator = queryString ? "&" : "?";
  return getData(`${endpoints.reports.salesTopProducts}${queryString}${separator}limit=${limit}`);
};

export const getSalesPaymentMethods = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.salesPaymentMethods}${queryString}`);
};

// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const getSalesTopClients = (params: DateRangeParams = {}, limit: number = 10) => {
  const queryString = buildQueryString(params);
  const separator = queryString ? "&" : "?";
  return getData(`${endpoints.reports.salesTopClients}${queryString}${separator}limit=${limit}`);
};

// ==================== MARKETING REPORTS ====================

export const getMarketingLeadConversion = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.marketingLeadConversion}${queryString}`);
};

export const getMarketingCampaignPerformance = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.marketingCampaignPerformance}${queryString}`);
};

export const getMarketingClientSegmentation = () => {
  return getData(endpoints.reports.marketingClientSegmentation);
};

export const getMarketingAgentPerformance = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.marketingAgentPerformance}${queryString}`);
};

// ==================== SUPPORT REPORTS ====================

export const getSupportTasksOverview = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.supportTasksOverview}${queryString}`);
};

export const getSupportTicketsOverview = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.supportTicketsOverview}${queryString}`);
};

export const getSupportResponseTimes = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.supportResponseTimes}${queryString}`);
};

export const getSupportAgentWorkload = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  return getData(`${endpoints.reports.supportAgentWorkload}${queryString}`);
};

// ==================== EXPORT FUNCTIONS ====================

/**
 * Export sales report as CSV
 */
export const exportSalesReport = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  window.open(`${endpoints.reports.exportSales}${queryString}`, "_blank");
};

/**
 * Export marketing report as CSV
 */
export const exportMarketingReport = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  window.open(`${endpoints.reports.exportMarketing}${queryString}`, "_blank");
};

/**
 * Export support report as CSV
 */
export const exportSupportReport = (params: DateRangeParams = {}) => {
  const queryString = buildQueryString(params);
  window.open(`${endpoints.reports.exportSupport}${queryString}`, "_blank");
};
